import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
const StylableGameIconAndLabel = ({ label, gameIcon }) => {
    if (!gameIcon) {
        return null;
    }
    return (React.createElement("div", { className: label && label.length > 0 ? "game-icon-and-label" : "game-icon-no-label" },
        React.createElement("div", { className: "game-icon" },
            React.createElement("img", { className: "game-icon-img", "data-testid": "game-label-img", src: gameIcon?.url, key: gameIcon?.accessibilityText, alt: gameIcon?.accessibilityText })),
        React.createElement("div", { className: "game-label" },
            React.createElement("h2", { className: "game-label-text", "data-testid": "game-label-text" }, label))));
};
export const GameIconAndLabel = styled(StylableGameIconAndLabel) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=GameIconAndLabel.js.map